export default {
  functional: true,
  render: function (createElement, context) {
    const data = {
      props: {
        name: "accordion-transition"
      },
      on: {
        beforeEnter: el => {
          el.style.height = "0";
        },
        enter: el => {
          el.style.height = el.scrollHeight + "px";
        },
        beforeLeave: el => {
          el.style.height = el.scrollHeight + "px";
        },
        leave: el => {
          el.style.height = "0";
        }
      }
    };
    return createElement("transition", data, context.children);
  }
};
